import classnames from 'classnames'
import React from 'react'

import { encodeQueryString } from '../../queryString'
import { ForexFuturesCryptoSettings } from '../../shared/components/ForexFuturesCryptoSettings'
import Sparkline from '../../shared/components/Sparkline'
import TilesStore from '../stores/tilesStore'

interface ChartMenuProps {
  activeGroup: string
  activeTile: string
  activeTimeframe: string
  activeRange?: string
  type: string
  showChartControls?: boolean
  isRedesignEnabled?: boolean
}

export function ChartMenu({
  activeGroup,
  activeTile,
  activeTimeframe,
  activeRange,
  type,
  showChartControls = true,
  isRedesignEnabled,
}: ChartMenuProps) {
  const isInteractiveActive = type === '1'
  const [tiles, setTiles] = React.useState(TilesStore.getTilesInGroup(activeGroup))

  React.useEffect(() => {
    const onStoreChange = () => setTiles(TilesStore.getTilesInGroup(activeGroup))

    TilesStore.addChangeListener(onStoreChange)

    return () => TilesStore.removeChangeListener(onStoreChange)
  }, [activeGroup])

  const interactiveUrl = FinvizSettings.hasUserPremium
    ? `/futures_charts.ashx?${encodeQueryString({
        t: activeTile,
        p: activeTimeframe,
        ty: 1,
      })}`
    : `/elite.ashx?${encodeQueryString({
        utm_source: 'finviz',
        utm_medium: 'banner',
        utm_campaign: 'futures-interactive-chart',
      })}`

  const getTileHref = (ticker: string) =>
    `/futures_charts.ashx?${encodeQueryString({
      t: ticker,
      p: activeTimeframe,
      ty: isRedesignEnabled && isInteractiveActive ? undefined : type,
      r: activeRange,
    })}`

  return (
    <div className="chart-menu">
      {showChartControls && (
        <ul className="chart-menu_type">
          <li className={classnames('is-static', { 'is-active': !isInteractiveActive })}>
            <a
              href={`/futures_charts.ashx?${encodeQueryString({
                t: activeTile,
                p: activeTimeframe,
                ty: undefined,
                r: activeRange,
              })}`}
              data-testid="futures-static"
            >
              Static
            </a>
          </li>
          <li
            className={classnames('is-interactive flex items-center justify-between', {
              'is-active': isInteractiveActive,
            })}
          >
            <a className="grow" href={interactiveUrl} data-testid="futures-interactive">
              Interactive
            </a>
            {isInteractiveActive && <ForexFuturesCryptoSettings isPremium={FinvizSettings.hasUserPremium} />}
          </li>
        </ul>
      )}
      <div className="chart-menu_charts">
        {tiles.map((tile) => (
          <a
            key={tile.ticker}
            className={classnames('chart-menu_chart-preview', { 'is-active': tile.ticker === activeTile })}
            href={getTileHref(tile.ticker)}
          >
            <span>{tile.label}</span>
            <Sparkline width={88} height={28} data={tile.sparkline} />
          </a>
        ))}
      </div>
    </div>
  )
}
